<template>
  <div class="h-screen bg-gray-100">
    <div class="flex w-full justify-start">
      <div class="md:w-full">
        <div>
          <div>
            <div>
              <div
                v-for="(item, i) in documentTypes"
                :key="i"
                class="rows border border-gray-300 w-full"
              >
                <div class="flex pl-2 items-center">
                  <div v-if="item.document_type_id === selectedDocumentType">
                    <img
                      src="/icons/radio-checked.svg"
                      alt="radio-checked"
                      width="24px"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="/icons/radio-unchecked.svg"
                      alt="radio-unchecked"
                      width="24px"
                    />
                  </div>
                  <button
                    text
                    class="p-2 w-full flex text-left !text-xs sm:!text-sm justify-start break-words"
                    @click="selectedRow(item)"
                  >
                    {{ item.document_type }}
                    <!-- {{ item.document_type_id }} -->
                  </button>
                </div>
              </div>
              <div>
                <div
                  class="text-center pt-4 sm:flex mx-10 space-y-2 sm:space-y-0"
                >
                  <v-btn class="w-full sm:w-1/2 mr-2" @click="cancelRequest">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="w-full sm:w-1/2"
                    @click="on_submit_request_for_document"
                  >
                    Submit Request
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <v-dialog
      v-model="dialog"
      persistent
      width="50%"
      :overlay="false"
      transition="dialog-transition"
    >
      <div class="bg_dialog">
        <div class="text-center p-20 dia_bg">
          <h1 class="text-xl font-bold">
            Your request for documents have been received.
          </h1>
          <div>
            Your requested documents will be sent to you via email. You may see
            the status of your request on your Dashboard. If you would like to
            claim documents at our head office, you will need to request to Book
            an Appointment.
          </div>
        </div>
        <div class="px-10 py-10 pt-10 flex justify-center">
          <v-btn dark class="w-1/2 mr-2" color="black" to="/my-documents"
            >Back to Home Page</v-btn
          >
          <v-btn dark class="w-1/2" color="black" to="/home/customer-dashboard"
            >Dashboard</v-btn
          >
        </div>
      </div>
    </v-dialog> -->
  </div>
</template>

<script>
import axios from "axios";
import SecureStorage from "../../../utils/secureStorage";
// import Back from "../../../common/BackButton.vue";

export default {
  data() {
    return {
      queryDataContractNumber: null,
      selectedDocumentType: null,
      document_type: null,
      document_type_id: null,
      dialog: false,
      documents: [],
      documentTypes: [],
      dt: [
        {
          document_type_id: "",
        },
      ],
    };
  },
  watch: {
    "$route.name": {
      handler(e) {
        if (e) {
          this.getDocumentTypes();
        }
      },
      immediate: true,
    },
  },
  // components: { Back },
  methods: {
    cancelRequest() {
      this.$emit("cancelRequest");
      this.resetVariables();
    },
    resetVariables() {
      this.selectedDocumentType = "";
      this.document_type_id = "";
      this.document_type = "";
    },
    selectedRow(itemSelected) {
      this.selectedDocumentType = itemSelected.document_type_id;
      this.document_type_id = itemSelected.document_type_id;
      this.document_type = itemSelected.document_type;
    },
    onPressBack() {
      this.$router.push({ name: "My Documents" });
    },
    on_submit_request_for_document() {
      try {
        if (this.document_type_id) {
          this.addToTicketFunction();
        } else {
          alert("Please select a document type");
        }
      } catch (error) {
        console.error("Error processing request:", error);
        alert(
          "An error occurred while processing your request. Please try again later."
        );
      }
    },
    addToTicketFunction() {
      let data = {
        appointment_purposes: `Request for Scanned Documents of ${this.document_type}`,
        user_id: SecureStorage.getItem("auth").userId,
        status_id: 1,
        remarks_id: 1,
        classification_id: 1,
        department_id: 10,
        subject: `Request for Scanned Documents of ${this.document_type}`,
        contract_number: this.$route.query.cn,
        customer_code: this.$route.query.cc,
        property: SecureStorage.getItem("auth").property,
        buyer_name: SecureStorage.getItem("auth").buyerName,
        document_type_id: this.document_type_id,
        email: SecureStorage.getItem("auth").email,
      };
      try {
        axios.post("/tickets/add", data).then((res) => {
          if (res.status) {
            this.resetVariables();
            this.$emit("onFinalSelectedDocs", data);
          }
        });
      } catch (error) {
        console.error("Error adding ticket:", error);
        alert(
          "An error occurred while processing your request. Please try again later."
        );
      }
    },
    getDocumentTypes() {
      axios.get("/document_types/get").then((res) => {
        this.documentTypes = res.data.map((x) => ({
          ...x,
          radioBtnOn: false,
        }));
      });
    },
  },
};
</script>

<style scoped>
img {
  max-width: initial;
}
.header {
  background: #e9967a;
}
.subheader {
  background: #faebd7;
}
.btn1 {
  background: #e9967a;
}
.btn2 {
  background: #faebd7;
}
/* .rows {
  background: #fff5ee;
} */
.bg_color_btn {
  background: #000;
  background-image: linear-gradient(-10deg, #000, #505050);
}
.bg_color_btn:hover {
  background: linear-gradient(-10deg, #7e1e06, #e97e04);
}
.bg_dialog {
  background: #faebd7;
}
.dia_bg {
  background: #faebd7;
}
</style>
